import {AsyncAnalyticsDataDto, ErrorDtoFactory, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {ActionType} from "../actionTypes";
import axios from "axios";
import envManager from "../../com/envManager/EnvManager";
import {Action as AnalyticsActions} from "../actions/analyticsActions";

export const getAnalyticsDataForSelectedFlyer = (flyerId: number) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<AsyncAnalyticsDataDto>) => {
        dispatch({
            type: ActionType.GET_ANALYTICS_DATA_FOR_FLYER_START
        })
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let result = await axios.post(`${envManager.flyerShopperServerAddress}/api/FlyersAnalytics/GetImpressionsOrdersDailySummary?flyerId=${flyerId}`, config);
            let data = result.data;
            dispatch({
                type: ActionType.GET_ANALYTICS_DATA_FOR_FLYER_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.GET_ANALYTICS_DATA_FOR_FLYER_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.GET_ANALYTICS_DATA_FOR_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


export const downloadExcelFileWithAnalyticsReportForSelectedFlyer = (flyerID: number, flyerCaption: string) => {
    return async (
        dispatch: Dispatch<AnalyticsActions>
    ) => {
        dispatch({
            type: ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_START,
        });

        try {
            let result: any = await downloadAnalyticsReportExcel(flyerID);
            const url = window.URL.createObjectURL(new Blob([result.data])); // you can mention a type if you wish
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${flyerCaption}-Analytics-Report.xlsx`); //this is the name with which the file will be downloaded
            link.click();
            dispatch({type: ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_SUCCESS});
            // no need to append link as child to body.
            setTimeout(() => window.URL.revokeObjectURL(url), 0);
            dispatch({type: ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

const downloadAnalyticsReportExcel = (flyerId: number) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            let url = `${envManager.flyerShopperServerAddress}/api/FlyersAnalytics/GetFlyerAnalyticsByDayExcel?flyerId=${flyerId}`;
            let result: any = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    // "Content-Type": "multipart/form-data",
                    contentType: 'application/json; charset=utf-8',
                    Authorization: "Bearer " + userDto.token,
                },
            });
            resolve(result);
        } catch (error) {
            new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    if (typeof reader?.result === "string") {
                        error.response.data = JSON.parse(reader?.result);
                    }
                    resolve(error);
                };

                reader.onerror = () => {
                    reject(error);
                };

                reader.readAsText(error.response.data);
            })
                .then(err => {
                    // here your response comes
                    reject(err);
                })

        }
    });
};

